import { Link } from "react-router-dom";
import { ShoppingCart, Package, Repeat } from "lucide-react";
import { Action } from "../../components/ui/Action";

export function Sales() {
  return (
    <div className="w-full rounded-lg border-zinc-200/30 shadow-md border p-4 gap-4 flex flex-col sm:col-span-2 md:col-span-1 md:row-span-3 lg:col-span-3 lg:row-span-2 xl:col-span-4 xl:row-span-3 bg-white">
      <div className="w-full flex">
        <spa className="flex gap-2 text-scale-500 font-semibold text-lg items-center">
          <ShoppingCart /> Vendas
        </spa>
      </div>
      <div className="w-full flex-wrap flex gap-2 mt-auto [&>div]:w-full [&>div]:w-min-fit [&>div]:flex-1">
        <Action.Root outline asChild className="flex-1 w-full !max-w-full">
          <Link to="/assinaturas?tab=assinantes&new=true">
            <Action.Icon icon={Repeat} /> Assinatura
          </Link>
        </Action.Root>
        <Action.Root outline asChild className="flex-1 w-full !max-w-full">
          <Link to="/pacotes">
            <Action.Icon icon={Package} /> Pacote
          </Link>
        </Action.Root>
      </div>
    </div>
  );
}
